import {Controller, useFormContext} from "react-hook-form";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import {useMemo, useRef} from "react";
import {message, Space} from "antd";
import {FormField, FormFieldError} from "../../../../../../../design-system/form-field";
import {StyledEditorWrapper} from "../../../../../../input/input.style";
import {SessionSubGenInfoDescriptionFormFieldProps} from "./types";
import {SessionGenInfoFormFields} from "../../types";

export function SessionSubGenInfoDescriptionFormField({
  id,
  label,
  placeholder,
}: SessionSubGenInfoDescriptionFormFieldProps) {
  const {control} = useFormContext<SessionGenInfoFormFields>();
  const quillRef = useRef<ReactQuill | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);

  function handleContentInputChange(e: React.ChangeEvent<HTMLInputElement>) {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      if (file.size > 50 * 1024) {
        return message.error("Max file size is 50kb");
      } else {
        const reader = new FileReader();
        reader.onload = function (event) {
          if (event.target && event.target.result) {
            const imageData = event.target.result;

            if (quillRef.current) {
              let quillObj = quillRef.current.getEditor();
              const range = quillObj.getSelection();
              if (range) {
                quillObj.insertEmbed(range.index, "image", imageData);
              } else {
                console.log("No range");
              }
            } else {
              console.log("No Quill instance");
            }
          }
        };
        if (fileInputRef.current?.files) {
          reader.readAsDataURL(fileInputRef.current.files[0]);
        }
      }
    }
  }
  const modules = useMemo(
    () => ({
      toolbar: {
        container: [
          [{font: []}],
          [{header: [1, 2, 3, 4, 5, 6, false]}],
          ["bold", "italic", "underline", "strike"],
          [{color: []}, {background: []}],
          [{script: "sub"}, {script: "super"}],
          ["blockquote", "code-block"],
          [{list: "ordered"}, {list: "bullet"}],

          [{indent: "-1"}, {indent: "+1"}, {align: []}],
          [{direction: "rtl"}],
          [{size: ["small", false, "large", "huge"]}],
          ["link", "image", "video"],
          ["clean"],
        ],
        history: {
          delay: 500,
          maxStack: 100,
          userOnly: true,
        },
      },
    }),
    []
  );

  return (
    <div>
      <FormField
        id={id}
        label={label}
        renderInput={(id) => (
          <Controller
            name="description"
            control={control}
            render={({field: {onChange, value, onBlur}, fieldState: {error}}) => (
              <>
                <input
                  ref={fileInputRef}
                  type="file"
                  onChange={handleContentInputChange}
                  style={{display: "none"}}
                />
                <Space direction="vertical" size={16} style={{display: "flex"}}>
                  <StyledEditorWrapper>
                    <ReactQuill
                      id={id}
                      ref={quillRef}
                      theme="snow"
                      style={{border: error?.message ? "1px solid #ff4d4f" : "initial"}}
                      onChange={(
                        _value,
                        _delta,
                        _source,
                        editor: ReactQuill.UnprivilegedEditor
                      ) => {
                        const editorHtml = editor.getHTML();
                        const editorTextLength = editor.getLength();
                        if (editorTextLength > 1) {
                          onChange(editorHtml);
                        } else {
                          onChange("");
                        }
                      }}
                      onBlur={onBlur}
                      value={value}
                      placeholder={placeholder}
                      modules={modules}
                    />
                  </StyledEditorWrapper>
                  <FormFieldError errorMessage={error?.message} />
                </Space>
              </>
            )}
          />
        )}
      />
    </div>
  );
}
